import React, { useState } from "react";
import {
  Box,
  Stack,
  Typography,
  Grid,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  useMediaQuery,
} from "@mui/material";
import Email from "@mui/icons-material/Email";
import Facebook from "@mui/icons-material/Facebook";
import Instagram from "@mui/icons-material/Instagram";
import LinkedIn from "@mui/icons-material/LinkedIn";
import LocationOn from "@mui/icons-material/LocationOn";
import Phone from "@mui/icons-material/Phone";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    subject: "",
    message: "",
  });

  const handleInputChange = (field) => (event) => {
    setFormData({ ...formData, [field]: event.target.value });
  };

  const handleSubjectChange = (event) => {
    setFormData({ ...formData, subject: event.target.value });
  };

  const isMobile = useMediaQuery("(max-width:1439px)");

  const subjectOptions = ["General Inquiry", "Careers", "Services", "Products"];

  const contactInfo = {
    phone: "077 756 5445",
    email: "rubaai@gmail.com",
    address: "No 08, Thiruvalluvar Supermarket, Bustand Building, Mannar.",
  };

  return (
    <Box
      sx={{
        background: "#000000",
        width: "100%",
        minHeight: "50vh",
        fontFamily: "Roboto",
        px: isMobile ? 2 : 0,
        py: isMobile ? 4 : 0,
        overflow: "hidden",
      }}
    >
      {/* ================= HERO SECTION WITH BLUE GLOW (ADDED) ================= */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
          overflow: "hidden",
          py: isMobile ? 4 : 6,
        }}
      >
        {/* Blue Glow Background (same as Blog page) */}
        <Box
          sx={{
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "-20%",
            left: 0,
            background:
              "radial-gradient(50% 50% at 50% 0%, rgba(94,176,239,0.5) 0%, rgba(255,255,255,0) 100%)",
            zIndex: 0,
          }}
        />

        {/* Title Section */}
        <Box sx={{ textAlign: "center", px: 2, position: "relative", zIndex: 1 }}>
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: isMobile ? "28px" : "54px",
              lineHeight: isMobile ? "36px" : "64px",
              color: "white",
              mb: 2,
            }}
          >
            Contact Us
          </Typography>
          <Typography
            sx={{
              fontSize: isMobile ? "16px" : "24px",
              color: "white",
              maxWidth: isMobile ? "300px" : "1140px",
              mx: "auto",
            }}
          >
            Interested in working with us? Let us know your expectations and
            specific needs. Reach out today, and let&apos;s explore how we can
            collaborate effectively!
          </Typography>
        </Box>
      </Box>

      {/* ================= MAIN WHITE CONTAINER (UNCHANGED) ================= */}
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: isMobile ? "12px" : "18px",
          border: isMobile ? "4px solid white" : "10px solid white",
          maxWidth: isMobile ? "375px" : "1100px",
          mx: "auto",
          overflow: "hidden",
          boxShadow: isMobile
            ? "0px 0px 20px rgba(0,0,0,0.1)"
            : "0px 0px 30px rgba(0,0,0,0.15)",
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        {/* Black Info Card */}
        <Box
          sx={{
            background: "black",
            color: "white",
            p: isMobile ? 3 : 5,
            width: isMobile ? "100%" : "40%",
            borderRadius: "10px",
            mb: isMobile ? 3 : 0,
            alignItems: isMobile ? "center" : "flex-start",
            textAlign: isMobile ? "center" : "left",
          }}
        >
          <Typography sx={{ fontSize: isMobile ? "20px" : "28px", fontWeight: 600, mb: 2 }}>
            Contact Information
          </Typography>
          <Typography sx={{ fontSize: isMobile ? "14px" : "18px", color: "#c8c8c8", mb: 3 }}>
            Say something to start a live chat!
          </Typography>

          <Stack spacing={isMobile ? 7 : 6} sx={{ mb: isMobile ? 6 : 20 }}>
            <Stack direction={isMobile ? "column" : "row"} spacing={1} alignItems="center">
              <Phone />
              <Typography>{contactInfo.phone}</Typography>
            </Stack>
            <Stack direction={isMobile ? "column" : "row"} spacing={1} alignItems="center">
              <Email />
              <Typography>{contactInfo.email}</Typography>
            </Stack>
            <Stack direction={isMobile ? "column" : "row"} spacing={1} alignItems="center">
              <LocationOn />
              <Typography sx={{ maxWidth: 260 }}>{contactInfo.address}</Typography>
            </Stack>
          </Stack>

          <Stack direction="row" spacing={2} justifyContent={isMobile ? "center" : "flex-start"}>
            {[Facebook, Instagram, LinkedIn].map((Icon, i) => (
              <Box
                key={i}
                sx={{
                  width: 30,
                  height: 30,
                  borderRadius: "50%",
                  backgroundColor: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon sx={{ fontSize: 16, color: "black" }} />
              </Box>
            ))}
          </Stack>
        </Box>

        {/* Contact Form */}
        <Box sx={{ width: isMobile ? "100%" : "60%", p: isMobile ? 3 : 5 }}>
          <Grid container spacing={isMobile ? 2 : 3}>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="First Name" variant="standard"  placeholder=" Fatima" value={formData.firstName} onChange={handleInputChange("firstName")}   InputProps={{
    sx: {
      "& input::placeholder": {
        color: "#CFCFCF",
        opacity: 1,
      },
    },
  }}/>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="Last Name" variant="standard" placeholder="  Ashta" value={formData.lastName} onChange={handleInputChange("lastName")} InputProps={{
  sx: {
    "& input::placeholder": {
      color: "#CFCFCF",
      opacity: 1,
    },
  },
}}/>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="Email" variant="standard"  placeholder=" example@email.com" value={formData.email} onChange={handleInputChange("email")} InputProps={{
  sx: {
    "& input::placeholder": {
      color: "#CFCFCF",
      opacity: 1,
    },
  },
}}/>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="Phone Number" variant="standard" placeholder=" +94 775665223" value={formData.phoneNumber} onChange={handleInputChange("phoneNumber")} InputProps={{
  sx: {
    "& input::placeholder": {
      color: "#CFCFCF",
      opacity: 1,
    },
  },
}}/>
            </Grid>
          </Grid>

          <Box sx={{ mt: 3 }}>
            <Typography sx={{ fontWeight: 600, fontSize: "14px", mb: 1 }}>
              Select Subject?
            </Typography>
            <RadioGroup value={formData.subject} onChange={handleSubjectChange} row={!isMobile}>
              {subjectOptions.map((option, index) => (
                <FormControlLabel key={index} value={option} control={<Radio size="small" />} label={option} />
              ))}
            </RadioGroup>
          </Box>

          <TextField
            fullWidth
            label="Message"
            variant="standard"
            multiline
            rows={isMobile ? 3 : 2}
            sx={{ mt: 3 }}
            value={formData.message}
            onChange={handleInputChange("message")}
          />

          <Box sx={{ textAlign: "right", mt: 4 }}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "black",
                px: 5,
                py: 1.5,
                fontSize: "16px",
                borderRadius: "6px",
                "&:hover": { bgcolor: "#333" },
              }}
            >
              Send Message
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ContactUs;


